import $ from 'jquery';
import debounce from 'lodash-es/debounce';
import vue from './vue';
import { calculateIngressLengths } from './swiper';
import eventLiveStatus from './event-live-status'

const debounceTime = 1000;
const oldestArticlePublicationYear = 2000; //Consider getting from API later

export default function init(el) {
  if (!el) {
    return;
  }
  return createVue(el);
}

async function createVue(container) {
  const $archive = $(container);
  const id = container.id;

  const Vue = await vue();
  new Vue({
    el: '#' + id,
    data: {
      loading: false,
      pageChanged: false,
      posts_html: "",
      post_type: "",
      post_types: [],
      search_term: "",
      search_author: "",
      count: 0,
      posts_per_page: 8,
      page_number: 0,
      previous_page: 0,
      page_count: 0,
      requests: [],
      published: "",
      topic: "",
      hierarchies: [],
      terms: [],
      selected_hierarchies: [],
      selected_years: [],
      selected_post_types: [],
      selected_terms: [],
      translations: null,
      show_filters: true,
      show_events_in: "",
      years: [],
      taxonomies: ['post_tag', 'category', 'event_types', 'article_types', 'blog_types', 'project_types', 'case_types', 'environment_effect'],
    },

    beforeMount: function() {
      this.hierarchies = JSON.parse($("#hierarchies").html());
      this.terms = JSON.parse($("#terms").html());
      this.post_types = JSON.parse($("#post-types").html());
      this.posts_per_page = $archive.attr("data-posts-per-page");

      this.initYears();
      this.parseUrlParameters();
      this.fetchPosts();
    },

    updated: function () {
      this.$nextTick(function () {
        calculateIngressLengths(container);
        eventLiveStatus(container);
      });
    },

    computed: {
      activeThemes: function() {
        return this.hierarchies.themes.filter(function(theme) {
          return theme.is_active || theme.is_active == null;
        });
      },

      inactiveThemes: function() {
        return this.hierarchies.themes.filter(function(theme) {
          return theme.is_active === false;
        });
      },
    },

    methods: {
      initYears: function() {
        var currentYear = new Date().getFullYear();

        var years = [];
        for (var i = oldestArticlePublicationYear; i <= currentYear; i++) {
            years.push(i);
        }

        this.years = years.reverse();
      },

      getCurrentLanguage: function() {
        if (window.location.pathname.indexOf('/en/') >= 0) {
          return "en";
        } else if (window.location.pathname.indexOf('/sv/') >= 0) {
          return "sv";
        } else {
          return "fi";
        }
      },

      fetchPosts: function() {
        if (!this.loading) {
          this.startLoading();
        }
        $.get(this.generateFetchPostsUrl(), {
          beforeSend: (xhr) => {
            this.abortPreviousRequests();
            this.requests.push(xhr); //add new request to queue to be able to abort it later
          },
        }).then((response) => {
          this.posts_html = response.posts_html;
          this.count = response.post_count;
          this.page_count = response.page_count;
          this.stopLoading();
          this.scrollToTop();
          this.loading = false;
          this.$nextTick(() => {
            window.dispatchEvent(new Event('posts-loaded'))
          })
        }, () => {
          //if error happens, go back to old page
          this.page_number = this.previous_page;
          this.stopLoading();
        });
      },


      fetchPostsLoadMore: function() {
        this.startLoading();
        $.get(this.generateFetchPostsUrl(), {
          beforeSend: (xhr) => {
            this.abortPreviousRequests();
            this.requests.push(xhr); //add new request to queue to be able to abort it later
          },
        }).then((response) => {
          this.posts_html += response.posts_html;
          this.count = response.post_count;
          this.page_count = response.page_count;

          this.stopLoading();

          this.$nextTick(() => {
            window.dispatchEvent(new Event('posts-loaded'))
          })
        }, () => {
          //if error happens, go back to old page
          this.page_number = this.previous_page;
          this.stopLoading();
        });
      },


      debouncedFetchPosts: debounce(function() {
        this.fetchPosts();
      }, debounceTime),

      loadMore: function() {
        this.startLoading();
        this.previous_page = this.page_number;
        this.page_number = this.page_number + 1;
        this.fetchPostsLoadMore();
      },

      abortPreviousRequests: function() {
        let request;
        while (request = this.requests.shift()) {
        request.abort();
        }
      },


      changePage: function(newPage) {
        this.startLoading();
        this.previous_page = this.page_number;
        this.page_number = newPage;
        history.replaceState(null, null, this.generateCurrentPageUrl());
        this.debouncedFetchPosts();
        this.pageChanged = true;
      },


      search: function() {
        this.page_number = 0;
        history.replaceState(null, null, this.generateCurrentPageUrl());
        this.fetchPosts();
      },

      scrollToTop: function() {
        $('html, body').animate({
          scrollTop: $(".archive-js").offset().top - 200,
        }, 300);
      },

      parseUrlParameters: function() {
        //parse search term
        var search_term = getUrlParameter("search_term");
        if (typeof(search_term) !== 'undefined') this.search_term = search_term.replace(/\+/g, ' ');

        var search_author = getUrlParameter("search_author");
        if (typeof(search_author) !== 'undefined') this.search_author = search_author.replace(/\+/g, ' ');

        //parse publication years
        var years = getUrlParameter("publication_years");
        if (typeof(years) !== 'undefined' && years !== "") this.selected_years = years.split(',');

        //parse post types
        var post_types = getUrlParameter("post_types");
        if (typeof(post_types) !== 'undefined' && post_types !== "") {
            this.selected_post_types = this.findPostTypesForPostNames(post_types.split(','));
        }

        //parse topics, themes and projects
        var hierarchies = [];

        var topics = getUrlParameter("_topics");
        if (typeof(topics) !== 'undefined' && topics !== "") {
          topics = topics.split(',');
          topics = arrayOfStringsToArrayOfInts(topics);
          hierarchies = hierarchies.concat(topics);
        }

        var themes = getUrlParameter("_themes");
        if (typeof(themes) !== 'undefined' && themes !== "") {
          themes = themes.split(',');
          themes = arrayOfStringsToArrayOfInts(themes);
          hierarchies = hierarchies.concat(themes);
        }

        var projects = getUrlParameter("_projects");
        if (typeof(projects) !== 'undefined' && projects !== "") {
          projects = projects.split(',');
          projects = arrayOfStringsToArrayOfInts(projects);
          hierarchies = hierarchies.concat(projects);
        }

        var hideFilters = getUrlParameter("_hf");
        if (typeof(hideFilters) !== 'undefined' && hideFilters !== "") {
          this.show_filters = false;
        }

        var pageNumber = getUrlParameter("page_number");
        if (typeof(pageNumber) !== 'undefined' && pageNumber !== "") {
          this.page_number = Number(pageNumber);
        }

        //parse terms
        var terms = [];

        for (var i = 0; i < this.taxonomies.length; i++) {
          var taxonomy = this.taxonomies[i];
          var taxonomy_parameter = getUrlParameter("_" + taxonomy);
          if (!empty(taxonomy_parameter)) {
            var these_terms = arrayOfStringsToArrayOfInts(taxonomy_parameter.split(','));
            terms = terms.concat(these_terms);
          }
        }

        this.selected_hierarchies = this.findHierarchiesByIds(hierarchies);
        this.selected_terms = this.findTermsByIds(terms);
      },


      findPostTypesForPostNames: function(post_names) {
        post_names = post_names.map((name) => {
          switch (name) {
            case 'projects':
            case 'themes':
            case 'topics':
              return `sitra_${name}`;
            default:
              return name;
          }
        });

        var finded_post_types = [];
        for (var i = 0; i < this.post_types.length; i++) {
          if (post_names.indexOf(this.post_types[i].name) > -1) {
            finded_post_types.push(this.post_types[i]);
          }
        }
        return finded_post_types;
      },


      findHierarchiesByIds: function(hierarchy_ids) {
        var finded_hierarchies = [];

        //join projects, topics and themes
        var all_hierarchies = this.hierarchies.topics.concat(this.hierarchies.projects).concat(this.hierarchies.themes);

        for (var i = 0; i < all_hierarchies.length; i++) {
          if (hierarchy_ids.indexOf(parseInt(all_hierarchies[i].ID)) > -1) {
            finded_hierarchies.push(all_hierarchies[i]);
          }
        }
        return finded_hierarchies;
      },


      findTermsByIds: function(term_ids) {
        var finded_terms = [];
        var all_terms = this.getAllTerms();
        for (var i = 0; i < all_terms.length; i++) {
          if (typeof(all_terms[i]) !== 'undefined' &&
            typeof(all_terms[i].term_id) !== 'undefined' &&
            term_ids.indexOf(parseInt(all_terms[i].term_id)) > -1) {
            finded_terms.push(all_terms[i]);
          }
        }

        return finded_terms;
      },

      getAllTerms: function() {
        var terms = [];
        for (var i = 0; i < this.taxonomies.length; i++) {
          terms = terms.concat(this.terms[this.taxonomies[i]]);
        }
        return terms;
      },

      addTopic: function() {
        this.page_number = 0;
        this.selected_hierarchies.push(this.topic);
        history.replaceState(null, null, this.generateCurrentPageUrl());
        this.fetchPosts();
        this.topic = "";
      },

      removeTopic: function(topic) {
        this.page_number = 0;
        var index = this.selected_hierarchies.indexOf(topic);
        this.selected_hierarchies.splice(index, 1);
        history.replaceState(null, null, this.generateCurrentPageUrl());
        this.fetchPosts();
      },

      addPostType: function() {
        this.page_number = 0;
        this.selected_post_types.push(this.post_type);
        history.replaceState(null, null, this.generateCurrentPageUrl());
        this.fetchPosts();
        this.post_type = "";
      },

      removePostType: function(post_type) {
        this.page_number = 0;
        var index = this.selected_post_types.indexOf(post_type);
        this.selected_post_types.splice(index, 1);
        history.replaceState(null, null, this.generateCurrentPageUrl());
        this.fetchPosts();
      },

      addYear: function() {
        this.page_number = 0;
        this.selected_years.push(this.published);
        history.replaceState(null, null, this.generateCurrentPageUrl());
        this.fetchPosts();
        this.published = "";
      },

      removeYear: function(year) {
        this.page_number = 0;
        var index = this.selected_years.indexOf(year);
        this.selected_years.splice(index, 1);
        history.replaceState(null, null, this.generateCurrentPageUrl());
        this.fetchPosts();
      },

      isActive: function(pageNumber) {
        if (this.page_number === pageNumber) return true;
        return false;
      },

      hasNextPage: function() {
        if (this.page_number < (this.page_count - 1)) return true;
        return false;
      },

      hasPreviousPage: function() {
        if (this.page_number > 0) return true;
        return false;
      },

      postHasImage: function(post) {
        if (post.portrait_image === false) return false;
        return true;
      },

      getSelectedTermsByTaxonomy: function(taxonomy) {
        return this.selected_terms.filter(function(term) {
          return term.taxonomy === taxonomy;
        }).map(function(term) {
          return term.term_id;
        });
      },

      generateCurrentPageUrl: function() {
        return "?" + this.generateUrlParameters();
      },

      generateFetchPostsUrl: function() {
        return '/wp/wp-admin/admin-ajax.php?action=get_posts&' + this.generateUrlParameters() + 'lang=' + this.getCurrentLanguage();
      },

      generateUrlParameters: function() {
        var post_types = this.selected_post_types.map(function(x) {
          return x.name;
        });

        post_types = post_types.join();

        var projects = this.selected_hierarchies.filter(function(post) {
          return post.post_type === "sitra_projects";
        }).map(function(post) {
          return post.ID;
        });

        var themes = this.selected_hierarchies.filter(function(post) {
          return post.post_type === "sitra_themes";
        }).map(function(post) {
          return post.ID;
        });

        var topics = this.selected_hierarchies.filter(function(post) {
          return post.post_type === "sitra_topics";
        }).map(function(post) {
          return post.ID;
        });

        //generate url for terms in each taxonomy
        var term_part_of_url = "";
        if (this.selected_terms.length > 0) {
          for (var i = 0; i < this.taxonomies.length; i++) {
            term_part_of_url += "_" + this.taxonomies[i] + "=";
            term_part_of_url += encodeURIComponent(this.getSelectedTermsByTaxonomy(this.taxonomies[i]).join());
            term_part_of_url += "&";
          }
          term_part_of_url += "&term_relation=" + this.term_relation;
        }

        return 'post_types=' + encodeURIComponent(post_types) +
               '&page_number=' + encodeURIComponent(this.page_number) +
               '&posts_per_page=' + encodeURIComponent(this.posts_per_page) +
               '&search_term=' + encodeURIComponent(this.search_term) +
                '&search_author=' + encodeURIComponent(this.search_author) +
               '&publication_years=' + encodeURIComponent(this.selected_years.join()) +
               '&_topics=' + encodeURIComponent(topics.join()) +
               '&_projects=' + encodeURIComponent(projects.join()) +
               '&_themes=' + encodeURIComponent(themes.join()) +
               '&' + term_part_of_url +
               '&';
      },

      startLoading: function() {
        this.pageChanged = false;
        $(".archive-page-grid").css("opacity", 0.0);
        $(".loading-spinner").css("opacity", 1);
        $(".loading-spinner").css("display","block");
        this.loading = true;
      },

      stopLoading: function() {
        $(".archive-page-grid").css("opacity", 1);
        $(".loading-spinner").css("opacity", 0);
        $(".loading-spinner").css("display","none");
      },

      translate: function(key) {
        if (this.translations == null) this.initTranslations();
        return this.translations[key];
      },

      initTranslations: function() {
        this.translations = $.parseJSON($("#vue-js-translations").html());
      },
    },
  });
}

/* Gets url parameter
 * @see http://stackoverflow.com/questions/19491336/get-url-parameter-jquery-or-how-to-get-query-string-values-in-js
 */
function getUrlParameter(sParam) {
  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }
}


function arrayOfStringsToArrayOfInts(strings) {
  var ints = strings.map(function(item) {
    return parseInt(item, 10);
  });
  return ints;
}


function empty(value) {
  if (typeof(value) === 'undefined' || value === "" || value === null) return true;
  return false;
}
